import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import theme from "../theme/theme";
//import { ReactComponent as LogoIcon } from "../assets/logo_old-1.svg";
import logo from "../assets/logo.png";
import {
  getUserAccountDetails,
  resetUserAccountDetails,
  setFirstLogin,
} from "../redux/actions";
import GarwoodHelpPopup from "./GarwoodHelpPopup/GarwoodHelpPopup";
import { getAccessToken } from "../redux/cookie";
import Cookies from "universal-cookie";
import WelcomeMessage from "./WelcomeMessage/WelcomeMessage";
import { useEffect, useState } from "react";
import AccountDetailsModal from "./AccountDetailsModal/AccountDetailsModal";
import { SET_LOADING } from "../redux/action-types";
import { analytics } from "../analytics";
const cookies = new Cookies();

const Wrapper = styled.header`
  background-color: ${theme.colors.white};
  padding: 1em 1em;
  width: 100%;
  box-sizing: border-box;
  max-height: 75px;

  @media (max-width: 480px) {
    max-height: 65px;
  }

  nav {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;

    .navBarOptionsHolder {
      display: flex;
      gap: 10px;
      @media (max-width: 480px) {
        gap: 0;
        align-items: center;
      }
    }
  }

  .logo {
    cursor: pointer;
    width: 200px;
    @media (max-width: 480px) {
      width: 150px;
      margin-right: 10px;
    }
  }
`;

const LoginLink = styled.div`
  display: flex;
`;

const DashboardLink = styled.a`
  border-bottom: ${(props) =>
    `${
      props.isUnderlineVisible
        ? `3px solid ${theme.colors.primary}`
        : "3px solid white"
    }`};
  padding: 5px;
  letter-spacing: 0px;
  line-height: 1.25;
  text-decoration: none;
  color: ${theme.colors.primaryStrong2X};
  height: fit-content;
  font-weight: 700;
  cursor: pointer;
  te &:hover {
    color: ${theme.colors.primary};
  }

  .userName {
    color: ${theme.colors.primary};
  }
`;

const HeaderWithoutLogin = ({
  isLogOutButtonVisible,
  isHomeClickable = true,
  isHelpButtonVisible = true,
  isLogoLocationSignupPage = false,
  isWelcomeMessageHidden = false,
  isLogoClickFromAdvisorPortal = false,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [width, setWidth] = useState(null);
  const [isAccountDetailsModalVisible, setIsAccountDetailsModalVisible] =
    useState(false);
  const { userAccountDetails } = useSelector((state) => state.user);
  const [isHelpPopupVisible, setIsHelpPopupVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    handleResize();
  }, [setWidth]);

  useEffect(() => {
    dispatch(getUserAccountDetails());
    dispatch({ type: SET_LOADING, payload: true });
  }, [dispatch]);

  const handleLogoClick = () => {
    if (isLogoClickFromAdvisorPortal) {
      history.push("/advisor-portal-landing");
      return;
    }

    if (isLogoLocationSignupPage) {
      history.push("/");
      return;
    }

    if (!isHomeClickable) {
      return;
    }

    if (getAccessToken()) {
      if (pathname !== "/advisor-agreement") {
        history.push("/strategy-screen");
      } else {
        return;
      }
    } else {
      //history.push("/");
      window.open("https://tactivewealth.com/", "_blank");
    }
  };

  return (
    <Wrapper>
      {isAccountDetailsModalVisible && (
        <AccountDetailsModal onClose={setIsAccountDetailsModalVisible} />
      )}
      <nav>
        {/* <LogoIcon className="logo" onClick={handleLogoClick} /> */}
        <img className="logo" src={logo} alt="logo" onClick={handleLogoClick} />
        {!isWelcomeMessageHidden ? (
          <div className="navBarOptionsHolder">
            {((history.location.pathname === "/strategy-screen" ||
              history.location.pathname === "/temporary-password" ||
              history.location.pathname ===
                "/strategy-screen/:fromGoalSubmission" ||
              history.location.pathname === "/strategy-screen/fromManage") &&
              width < 481) || (
              <WelcomeMessage
                actionOnClick={() => {
                  if (isLogoClickFromAdvisorPortal) {
                    history.push("/advisor-portal-users-under-my-farm");
                  } else setIsAccountDetailsModalVisible(true);
                }}
              />
            )}
            <LoginLink>
              {isHelpPopupVisible && (
                <GarwoodHelpPopup
                  setIsHelpPopupVisible={setIsHelpPopupVisible}
                />
              )}
              {isHelpButtonVisible && (
                <DashboardLink
                  isUnderlineVisible={isHelpPopupVisible}
                  onClick={() => {
                    setIsHelpPopupVisible(true);
                  }}
                >
                  Help
                </DashboardLink>
              )}
            </LoginLink>
            <LoginLink>
              {isLogOutButtonVisible && (
                <DashboardLink
                  isUnderlineVisible={false}
                  onClick={() => {
                    analytics.track("Signed Out", {
                      userId: userAccountDetails?.id || "",
                    });
                    cookies.remove("accessToken");
                    dispatch(setFirstLogin(true));
                    dispatch(resetUserAccountDetails());

                    history.push("/");
                  }}
                >
                  Logout
                </DashboardLink>
              )}
            </LoginLink>
          </div>
        ) : (
          <LoginLink>
            {isHelpPopupVisible && (
              <GarwoodHelpPopup setIsHelpPopupVisible={setIsHelpPopupVisible} />
            )}
            {isHelpButtonVisible && (
              <DashboardLink
                isUnderlineVisible={isHelpPopupVisible}
                onClick={() => {
                  setIsHelpPopupVisible(true);
                }}
              >
                Help
              </DashboardLink>
            )}
          </LoginLink>
        )}
      </nav>
    </Wrapper>
  );
};

export default HeaderWithoutLogin;
